import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] p-4 z-50 md:hidden animate-in slide-in-from-bottom duration-300" data-id="element-151">
      <div className="flex items-center justify-between gap-4" data-id="element-152">
        <div className="flex flex-col" data-id="element-153">
          <span className="text-xs text-slate-500 line-through" data-id="element-154">Antes $47</span>
          <span className="text-xl font-black text-emerald-700" data-id="element-155">$6.39 USD</span>
        </div>
        <Button size="default" className="flex-1 text-sm py-3" href="https://www.viventispace.com/cart/45947227177148:1" data-id="element-156">
          QUIERO ALIVIO YA
        </Button>
      </div>
    </div>;
}